import { AlertPopup, HttpLoader } from './../../app.config';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, Directive } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { config } from '../../app.config';
import { ValidationService } from './../form-validation/validation.service';
import { PasswordResetService } from './password-reset.service';
import { DataSharingService } from 'app/shared/data-sharing.service';


// @Directive()
@Component({
    selector: 'app-forgot',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss'],
    standalone: false
})

export class PasswordResetComponent implements OnInit, AfterViewInit, OnDestroy {
  passwordResetForm: FormGroup;
  showMailConfirmation = false;
  @Input() emailIds: any;
  token: any = '';
  errorMessage: string ='';
  copyRights: number = config.copyrights;
  email_id:any;
  hostlogo: any;
  private subscribers: any = {};
  passwordChangeErr: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private resetService: PasswordResetService,
    private dataSharingService: DataSharingService,
    private alert: AlertPopup,
    private httpLoader: HttpLoader
  ) {
    this.passwordResetForm = formBuilder.group({
      password: [null, Validators.compose([Validators.required, ValidationService.passwordValidator])],
      confirm_password: [null, Validators.required]
    });
  }

  ngOnInit() {
    this.clearLocalStorage();

    this.token = this.route.snapshot.paramMap.get('token');
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    try {
      this.resetService.authenticateEmailId$.subscribe(data => {
        this.emailIds = data;

      })
    } catch (error) {
      console.log(error)
    }
  }


  clearLocalStorage() {
    window.localStorage.clear();
  };

  returnToLogin() {
    this.router.navigate(['/login']);
  };

  confirmResetPassword(value: { password: any; confirm_password: any }) {


    if (!value || !value.password || !value.confirm_password) return;

    if (value.password !== value.confirm_password) {
      this.passwordChangeErr = `Those Passwords did not match.`;
      setTimeout(() => {
        this.passwordChangeErr = "";
      }, 3000); // give user more time
      return;
    }

    const email_id = window.sessionStorage.getItem('email_id');
    if (!email_id) {
      this.alert.showAlertMessage('Email ID not found in session.');
      return;
    }

    const payLoad = {
      email_id,
      password: value.password,
    };


    this.httpLoader.showLoader();

    this.passwordChangeErr = '';
    this.resetService.requestResetPassword(payLoad).subscribe({
      next: (response:any) => {
        if(response['success']){
          this.showMailConfirmation = true;
          this.alert.showAlertMessage(response)
          this.httpLoader.hideLoader();
        }

      },
      error: (err) => {
        this.httpLoader.hideLoader();
        this.alert.showAlertMessage(err?.error || 'Something went wrong.');
      }
    });
  };

  redirectToSignIn() {
    this.router.navigate(['/login'])
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    // this.subscribers.userEmailId.unsubscribe();
  }

}

